module.exports = __webpack_public_path__ + "img/44.a0af2694.svg";